import React, { useEffect, useState } from 'react';
import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import DOMPurify from 'dompurify';
import styles from './MaintenanceBanner.module.scss';
import useHomeStore from "../../../../store/homeStore";
import Api from "../../../../api/Api";
import {ENotificationTypes} from "../../../features/Notifications/INotification";

export default function MaintenanceBanner() {
  const showMaintenanceBanner = useHomeStore(state => state.showMaintenanceBanner);
  const setShowMaintenanceBanner = useHomeStore(state => state.setShowMaintenanceBanner);
  const notifications = useHomeStore(state => state.notifications);
  const setNotifications = useHomeStore(state => state.setNotifications);

  const [maintenanceBannerText, setMaintenanceBannerText] = useState<string>('');

  useEffect(() => {
    if(Api?.configData){
      const json = Api.configData
      const currentDate = new Date();
      const showBannerUntilDate = new Date(json.showMaintenanceBannerUntil);

      if (json.showMaintenanceBanner === 'true' && currentDate < showBannerUntilDate) {
        // Sanitize the HTML content
        const sanitizedText = DOMPurify.sanitize(json.maintenanceBannerText);
        setMaintenanceBannerText(sanitizedText);
        setShowMaintenanceBanner('true');
        updateNotifications(json);
      } else {
        setShowMaintenanceBanner('false');
      }
    }
  }, [Api?.configData]);

  const updateNotifications = (json: {
    maintenanceBannerText: string
  }): void => {
    const notification = notifications;
    const notificationExists = notification.some(
      (x) => x.id === 'maintenance-notification-43c3-91ba-02698dcc98c9'
    );

    if (!notificationExists) {
      // Sanitize the HTML content for notification
      const sanitizedMessage = DOMPurify.sanitize(json.maintenanceBannerText);
      notification.push({
        id: 'maintenance-notification-43c3-91ba-02698dcc98c9',
        title: 'Maintenance',
        time: new Date().getTime(),
        message: sanitizedMessage,
        type: ENotificationTypes.MAINTENANCE,
      });
      setNotifications(notification);
    }
  };

  const dismissBanner = (): void => {
    localStorage.setItem('showMaintenanceBanner', 'false');
    setShowMaintenanceBanner('false');
  };

  return showMaintenanceBanner === 'true' ? (
    <div className={styles.root}>
      <div className={styles.warningIcon}>
        <WarningOutlined />
      </div>
      <div
        className={styles.message}
        dangerouslySetInnerHTML={{ __html: maintenanceBannerText }}
      />
      <div className={styles.closeBtn} onClick={dismissBanner}>
        <p>dismiss</p> <CloseOutlined />
      </div>
    </div>
  ) : null;
}
